import MobileDetect from "mobile-detect";
import { injectScript } from "./../../utilities/DOMUtils";
import { deviceType, XitiMode } from "./../../utilities/enums";
import AnalyticsEngineBase from "./../analyticsenginebase";
import * as eventNames from "./../analyticsevents";

export default class AnalyticsEngineXiTiBase extends AnalyticsEngineBase {
  constructor(analyticsManager, options = {}) {
    super(analyticsManager, options);
    const url = this._buildScriptUrl();
    injectScript(
      url,
      this._onXitiScriptLoaded,
      false,
      this._options.xitiScriptAttributes
    );
    this._subscribeToEvents();
    this._mode = options.XitiStartMode;
  }

  _buildScriptUrl() {
    let site;

    if (this._options.scriptFiles) {
      site = this._isDesktop()
        ? this._options.scriptFiles.desktop
        : this._options.scriptFiles.mobile;
    }

    if (site) {
      return `${this._options.xitiScriptUrl}/${site}`;
    }
    return this._options.xitiScriptUrl;
  }

  set mode(value) {
    this._mode = value;
  }

  get mode() {
    return this._mode;
  }

  _subscribeToEvents() {
    this._subscribeToPageViews();
  }

  _onXitiScriptLoaded = () => {
    if (this._options.siteIds) {
      this.tag = this._isDesktop()
        ? new window.ATInternet.Tracker.Tag({
            site: this._options.siteIds.desktop,
          })
        : new window.ATInternet.Tracker.Tag({
            site: this._options.siteIds.mobile,
          });
    } else {
      this.tag = new window.ATInternet.Tracker.Tag();
    }
    if (this.tag) {
      // Mode can either be Full or Minimal and must be enabled after the script has loaded
      if (this.mode === XitiMode.FULL) {
        this.tag.identifiedVisitor.set({
          category: "1",
        });
        this.enableFullMode();
      } else {
        if (this.tag.privacy && this._options.xitiPrivacyOptions) {
          this.tag.privacy.extendIncludeBuffer(
            this._options.xitiPrivacyOptions
          );
        }
        this.enableMinimalMode();
      }
    }
  };

  enableMinimalMode() {
    if (this.tag.privacy) this.tag.privacy.setVisitorMode("cnil", "exempt");
  }

  enableFullMode() {
    if (this.tag.privacy) this.tag.privacy.setVisitorOptin();
  }

  _subscribeToPageViews() {
    this._analyticsManagerBase.on(eventNames.VIEW_PAGE, (data) => {
      this._sendPageEvent(data);
    });
    this._analyticsManagerBase.on(
      eventNames.VIEW_PAGE_IN_BACKGROUND,
      (data) => {
        this._sendPageEvent(data);
      }
    );

    this._analyticsManagerBase.on(eventNames.VIEW_ARTICLE_ALB, (data) => {
      this._sendArticleEvent(data);
    });
  }

  _sendArticleEvent(data) {
    if (this.tag) {
      const {
        eventData: {
          bundle: {
            publication: { pages },
          },
        },
      } = data;
      const {
        eventData: { bundle },
      } = data;
      if (this.mode == XitiMode.FULL) {
        this.tag.identifiedVisitor.set({
          category: this.IdentifyVisitor(data),
        });
      }
      this.tag.page.set(this.getArticleLabel(bundle, pages[0]));
      this.tag.dispatch();
    }
  }

  _sendPageEvent(data) {
    if (this.tag) {
      const {
        eventData: {
          bundle: {
            publication: { pages },
          },
        },
      } = data;
      const {
        eventData: { bundle },
      } = data;
      if (this.mode == XitiMode.FULL) {
        this.tag.identifiedVisitor.set({
          category: this.IdentifyVisitor(data),
        });
      }
      if (pages.length > 0) {
        pages.forEach((page) => {
          this.tag.page.set(this.getPageLabel(bundle, page));
          this.tag.dispatch();
        });
      }
    }
  }

  sendHomeOpenedEvent(data) {
    if (this.mode == XitiMode.FULL) {
      this.tag.identifiedVisitor.set({
        category: this.IdentifyVisitor(data),
      });
    }

    this.tag.page.set(this.getHomeLabel(data));
    this.tag.dispatch();
  }

  _isDesktop() {
    let isDesktop = true;

    const md = new MobileDetect(navigator.userAgent);

    // mobile or tablet:
    if (md.mobile()) {
      isDesktop = false;
    } else {
      isDesktop = true;
    }
    return isDesktop;
  }

  getDeviceType() {
    const md = new MobileDetect(navigator.userAgent);

    if (md.mobile()) {
      if (md.phone()) {
        return deviceType.PHONE;
      } else {
        return deviceType.TABLET;
      }
    }
    return deviceType.DESKTOP;
  }
}



// WEBPACK FOOTER //
// ./src/common/analytics/engines/analyticsEngineXiTiBase.js